module.exports = new __parcel__URL__("homebase_loading_text.62bb3372.png").toString();